@if ($isVisible()) {
  <div class="dropdown-container" #scrollContainer>
    @if ($hasResults()) {
      @for (group of $groups(); track group.type; let groupLast = $last) {
        <div class="group" [class.divider]="!groupLast">
          @for (item of group.items; track item.id; let i = $index) {
            <button class="item" [class.active]="isActiveItem(item)" (click)="onItemClick(item)" (mouseenter)="onItemHover(getFlatIndex(group, i))">
              @switch (group.type) {
                @case ('job') {
                  <span class="dot-wrapper">
                    <span class="dot" [style.background]="item.color ?? '#155eef'"></span>
                  </span>
                }
                @case ('customer') {
                  <span class="icon-wrapper">
                    <i class="fa-regular fa-user"></i>
                  </span>
                }
                @case ('contact') {
                  <span class="avatar" [style.background]="item.color ?? '#155eef'">
                    {{ getInitials(item.label) }}
                  </span>
                }
              }
              <span class="label">{{ item.label }}</span>
            </button>
          }
        </div>
      }
    } @else {
      <div class="empty-state">No results</div>
    }
  </div>
}